import { InvoiceThird } from './invoice-third.model';

export class InvoiceOrganization {
  ean?: string;
  fiscalCompany?: number;
  jdeNumber: number;
  region?: string;
  third?: InvoiceThird;

  constructor(values= {}) {
    Object.assign(this, values);
    this.third = this.third ? new InvoiceThird(this.third) : new InvoiceThird();
  }
}
